<template>
	<div class="w100" style=" background: #882123;">
		<article class="content-bg" style="padding-top: 40px;"></article>
		<div class="main-content">
			<div class="main-part1">
				<img class="juanzhoul" src="../../assets/images/2023/a18th/左侧线条.png"/>
				<img class="juanzhou" src="../../assets/images/2023/a18th/卷轴.png"/>
				<img class="juanzhour" src="../../assets/images/2023/a18th/右侧线条.png"/>
				
				<video-player class="video-player vjs-custom-skin"
				    ref="videoPlayer"
				    :playsinline="true"
				    :options="playerOptions">
				</video-player>
			</div>
			<!-- <div class="main-part1 noscroll">
				<img class="juanzhoul" src="../../assets/images/2023/a18th/左侧线条.png"/>
				<img class="juanzhour" src="../../assets/images/2023/a18th/右侧线条.png"/>
			</div> -->
			<div class="main-part p2">
				<div class="box">
					<img class="title" src="../../assets/images/2023/a18th/数据bus标题.png"/>
					<div class="content">
						<div class="part l">
							<img class="name" src="../../assets/images/2023/a18th/京津冀全数据.png"/>
							<img class="des" src="../../assets/images/2023/a18th/买一赠一.png"/>
						</div>
						<div class="part r">
							<img class="name" src="../../assets/images/2023/a18th/单一品类数据.png"/>
							<img class="des" src="../../assets/images/2023/a18th/买一赠一.png"/>
						</div>
					</div>
				</div>
			</div>
			
			<div class="main-part p31">
				<img class="title" src="../../assets/images/2023/a18th/分析报告类标题.png"/>
				<div class="content">
					<img class="name" src="../../assets/images/2023/a18th/唐山钢铁情报.png"/>
					<img class="des" src="../../assets/images/2023/a18th/20000元年.png"/>
				</div>
			</div>
			
			<div class="main-part p32">
				<div class="content">
					<div class="part l">
						<img class="name" src="../../assets/images/2023/a18th/钢坯全景会员.png"/>
						<img class="des" src="../../assets/images/2023/a18th/买一赠一.png"/>
					</div>
					<div class="part r">
						<img class="name" src="../../assets/images/2023/a18th/带钢全景会员.png"/>
						<img class="des" src="../../assets/images/2023/a18th/买一赠一.png"/>
					</div>
				</div>
				<div class="text">
					<p>1、唐宋钢铁在线监测预警单模块一年。2、市场分析报告（日度、周度、月度、年度）</p>
					<p>3、《唐尔街情报》4、钢坯/带钢微数据。5、钢坯/带钢价格短信息。6、行情交流群。</p>
					<p>7、数据人工助手。8、钢坯/带钢数据BUS一年。</p>
				</div>
			</div>
			
			<div class="main-part p41">
				<img class="title" src="../../assets/images/2023/a18th/大数据智能系统标题.png"/>
				<div class="content">
					<div class="box">
						<img class="name" src="../../assets/images/2023/a18th/钢铁在线监测预警全模块.png"/>
						<img class="des" src="../../assets/images/2023/a18th/35000元年.png"/>
					</div>
					<img class="bottom" src="../../assets/images/2023/a18th/大数据买一赠二.png"/>
				</div>
			</div>
			
			<div class="main-part p51">
				<img class="title" src="../../assets/images/2023/a18th/培训类标题.png"/>
				<div class="content">
					<div class="box">
						<img class="name" src="../../assets/images/2023/a18th/2人（次）高进阶培训班.png"/>
						<img class="des" src="../../assets/images/2023/a18th/50000元年.png"/>
					</div>
					<img class="bottom" src="../../assets/images/2023/a18th/培训买一赠一.png"/>
				</div>
			</div>
			
			<div class="main-bottom">
				<img src="../../assets/images/2023/a18th/客服热线.png"/>
			</div>
		</div>
		
		<div class="popup-zp-dialog" v-if="getDay() == 0">
			<el-dialog :visible.sync='showPopupZP' :close-on-click-modal="false" :height="600">
				<div class="popup-zp-box">
					<iframe src="/choujiang/zhuanpan.html"></iframe>
				</div>
			</el-dialog>
		</div>
		
		<div class="popup-zp-dialog-right" v-if="getDay() == 0">
			<div class="popup-zp-box" @click="showPopupZP = true">
				<img class="popup-zp1" src="../../assets/images/2023/circle2.png"></img>
				<img class="popup-zp2" src="../../assets/images/2023/button2.png"></img>
				<img class="popup-zp3" src="../../assets/images/2023/dizuo.png"></img>
			</div>
		</div>
		
		<!-- <ConcatsControl></ConcatsControl> -->
	</div>
</template>
<script>
	import $ from 'jquery'
	import QRCode from 'qrcode'
	import '../../assets/js/jquery.liMarquee.js'
	import {
		baseUrl,
		getQueryString,
		adIDs
	} from '../../assets/js/common'
	import ConcatsControl from '../../templates/concatsControl'
	export default {
		name: 'activitiesDetail2021gz',
		components: {
			ConcatsControl
		},
		data() {
			return {
				showPopupZP: false,
				playerOptions: {
					playbackRates: [0.5, 1.0, 1.5, 2.0],
					autoplay: false,
					muted: false,
					loop: false,
					preload: 'auto',
					language: 'zh-CN',
					aspectRatio: '16:9',
					fluid: true,
					notSupportedMessage: '此视频暂无法播放，请稍后再试',
					controlBar: {
					    timeDivider: true,
					    durationDisplay: true,
					    remainingTimeDisplay: false,
					    fullscreenToggle: true 
					},
					sources: [{
                        type: "video/mp4",
                        src: 'http://upload.dataingbank.com/8.17.mp4'
                    }]
				}
			}
		},
		mounted() {
			var that = this
			this.showPopupZP = this.$route.query.show && this.$route.query.show == 'true' ? true : false
			
			window.addEventListener('message', (e) => {
			    if(e.data.type == 'closeDialog') {
					that.showPopupZP = false
				}
			})
		},
		methods: {
			getDay() {
				const endDate = new Date('2023-08-09 00:00:00').valueOf()
				var d = new Date().valueOf()
				var day = Math.floor((endDate - d) / (24 * 60 * 60 * 1000))
				return day
			},
		}

	}
</script>

<style scoped>
	@import url('../../assets/css/liMarquee.css');

	.content-bg {
		background: url('../../assets/images/2023/a18th/top.jpg') no-repeat;
		background-size: 100% auto;
		position: relative;
		height: calc(100vw * (845 / 1920));
	}

	.logo-position {
		position: absolute;
		top: 60px;
		left: 60px;
		color: #fff;
	}

	.logo-position>p {
		font-size: 20px;
	}

	.logo-position>div>span {
		display: inline-block;
		margin-bottom: 20px;
		width: 8px;
		border-top: 2px solid #fff;
	}
	
	.main-content {
		width: 100%;
	}
	
	.main-part1 {
		text-align: center;
		height: calc(646px * (1100 / 1163));
		position: relative;
	}
	
	.main-part1.noscroll {
		text-align: center;
		height: 0;
		position: relative;
	}
	
	.main-part1 .juanzhou {
		width: 1100px;
		height: 612px;
		position: absolute;
		left: calc(50% - 550px);
		z-index: 2;
	}
	
	.main-part1 .juanzhoul {
		position: absolute;
		top: 10%;
		left: 0;
		width: calc(1131px * 0.6);
		height: 854px;
		z-index: 1;
	}
	
	.main-part1 .juanzhour {
		position: absolute;
		top: 10%;
		right: 0;
		height: 854px;
		z-index: 1;
	}
	
	.main-part1 .video-player {
		width: 846px;
		position: absolute;
		left: calc(50% - 434px);
		z-index: 999;
		top: 54px;
		height: 444px;
	}
	
	.main-part1::after {
		display: block;
		position: absolute;
		content: "";
		width: 858px;
		height: 486px;
		box-sizing: border-box;
		border: 6px solid #caad8a;
		top: 48px;
		left: calc(50% - 440px);
		z-index: 4;
	}
	
	.main-part1.noscroll::after {
		display: block;
		position: absolute;
		content: "";
		width: 858px;
		height: 0px;
		box-sizing: border-box;
		top: 48px;
		left: calc(50% - 440px);
		z-index: 4;
		border: none;
	}
	
	.main-part1.noscroll .juanzhoul {
		position: absolute;
		top: 5%;
		left: 0;
		width: calc(1131px * 0.6);
		height: 1060px;
		z-index: 0;
	}
	
	.main-part1.noscroll .juanzhour {
		position: absolute;
		top: 5%;
		right: 0;
		height: 1060px;
		z-index: 0;
	}
	
	.main-part {
		width: 1100px;
		margin: 0 auto;
	}
	
	.main-part .title {
		margin: 0 auto;
		display: block;
	}
	
	.main-part .content {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}
	
	.main-part .content .des {
		
	}
	
	.main-part .content .part {
		width: 341px;
		height: 322px;
		background: url('../../assets/images/2023/a18th/圆角矩形6.png');
		margin-top: 32px;
		position: relative;
		text-align: center;
	}
	
	.main-part .content .part.l {
		display: inline-block;
		margin-left: 172px;
	}
	
	.main-part .content .part.r {
		display: inline-block;
		margin-right: 172px;
	}
	
	.main-part .content .part .name {
		display: block;
		margin: 0 auto;
		margin-top: 40px;
	}
	
	.main-part .content .part .des {
		display: block;
		margin: 0 auto;
		margin-top: 40px;
		width: 292px;
		height: 32px;
	}
	
	.main-part.p2 {
		position: relative;
		width: 1100px;
		height: 400px;
	}
	
	.main-part.p2 .box {
		position: absolute;
		width: 1100px;
		z-index: 2;
	}
	
	.main-part.p2 .content .part.l .name {
		width: 183px;
		height: 126px;
	}
	
	.main-part.p2 .content .part.r .name {
		width: 240px;
		height: 126px;
	}
	
	.main-part.p2 .content {
		width: 100%;
		height: 414px;
		background: url('../../assets/images/2023/a18th/数据bus底图.png');
		margin-top: 20px;
	}
	
	.main-part .content .part::after {
		display: inline-block;
		display: block;
		position: absolute;
		content: "";
		width: 265px;
		height: 85px;
		bottom: -24px;
		left: 40px;
		right: 0;
		z-index: 4;
		background-size: 100% 100%;
	}
	
	.main-part.p2 .content .part.l::after {
		background: url('../../assets/images/2023/a18th/4999元年.png');
	}
	
	.main-part.p2 .content .part.r::after {
		background: url('../../assets/images/2023/a18th/1999元年.png');
	}
	
	.main-part.p31 {
		margin-top: 40px;
	}
	
	.main-part.p31 .content {
		height: 244px;
		margin-top: 20px;
		background: url('../../assets/images/2023/a18th/唐山钢铁情报底图.png');
		display: flex;
		justify-content: center;
		align-items: center;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	
	.main-part.p31 .content .name {
		width: 307px;
		height: 68px;
		margin-right: 10px;
	}
	
	.main-part.p31 .content .des {
		width: 273px;
		height: 88px;
		margin-left: 10px;
	}
	
	.main-part.p32 {
		margin-top: 20px;
		background: url('../../assets/images/2023/a18th/全景会员底图.png');
		height: 524px;
	}
	
	.main-part.p32 .content .part.l::after {
		background: url('../../assets/images/2023/a18th/50000元年.png');
	}
	
	.main-part.p32 .content .part.r::after {
		background: url('../../assets/images/2023/a18th/50000元年.png');
	}
	
	.main-part.p32 .text {
		margin-top: 50px;
		margin-left: 176px;
		font-size: 14px;
		color: #fff;
		line-height: 24px;
		letter-spacing: 6px;
	}
	
	.main-part.p41 {
		margin-top: 40px;
	}
	
	.main-part.p41 .content {
		height: 333px;
		margin-top: 20px;
		background: url('../../assets/images/2023/a18th/大数据底图.png');
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
	}
	
	
	.main-part.p41 .content .box {
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 40px;
	}
	
	.main-part.p41 .content .name {
		width: 558px;
		height: 68px;
		margin-right: 10px;
	}
	
	.main-part.p41 .content .des {
		width: 273px;
		height: 88px;
		margin-left: 10px;
	}
	
	.main-part.p51 {
		margin-top: 40px;
		padding-bottom: 40px;
	}
	
	.main-part.p51 .content {
		height: 333px;
		margin-top: 20px;
		background: url('../../assets/images/2023/a18th/大数据底图.png');
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
	}
	
	.main-part.p51 .content .box {
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		margin-bottom: 40px;
	}
	
	.main-part.p51 .content .box .name {
		width: 534px;
		height: 68px;
		margin-right: 10px;
	}
	
	.main-part.p51 .content .box .des {
		width: 273px;
		height: 88px;
		margin-left: 10px;
	}
	
	
	.popup-zp-dialog {
		
	}
	
	.popup-zp-dialog /deep/ .el-dialog {
		box-shadow: none;
		background-color: rgba(0, 0, 0, 0);
		margin-top: 4vh !important;
	}
	
	.popup-zp-dialog /deep/ .el-dialog__body {
		text-align: center;
	}
	
	.popup-zp-dialog /deep/ .el-dialog__headerbtn {
		position: ;
	}
	
	.popup-zp-dialog /deep/ .el-dialog__close {
		font-size: 40px;
		color: #FFFFFF;
		border: 2px solid #FFFFFF;
		border-radius: 100px;
		margin-right: 0px;
		margin-top: -20px;
	}
	
	.popup-zp {
		width: 480px;
		height: 480px;
	}
	
	.popup-zp-box iframe {
		width: 100%;
		height: 100%;
		border: none;
	}
	
	.popup-zp-dialog-right {
		position: fixed;
		top: -56px;
		right: -36px;
		z-index: 999;
		pointer-events: none;
	}
	
	.popup-zp-dialog-right {
		transition: all 0.32;
	}
	
	.popup-zp-dialog-right .popup-zp-box {
		transform: scale(0.4);
		transform-origin: 50% 50%;
		cursor: pointer;
	}
	
	.popup-zp-box {
		display: inline-block;
		position: relative;
		text-align: center;
		width: 560px;
		height: 720px;
		pointer-events: auto;
	}
	
	.popup-zp-dialog-right .popup-zp-box .popup-zp1 {
		position: absolute;
		width: calc(560px * 0.6);
		height: calc(560px * 0.6);
		top: 0%;
		left: calc(50% - 560px * 0.3);
		z-index: 2;
	}
	
	.popup-zp-dialog-right .popup-zp-box .popup-zp2 {
		position: absolute;
		width: calc(560px * 0.2);
		height: calc(560px * 0.22);
		top: calc(560px * 0.18);
		left: calc(50% - 560px * 0.1);
		z-index: 3;
	}
	
	.popup-zp-dialog-right .popup-zp-box .popup-zp3 {
		position: absolute;
		width: calc(560px * 0.64);
		height: calc(720px * 0.60);
		top: 0%;
		left: calc(50% - 560px * 0.32);
		z-index: 1;
	}
	
	.main-bottom {
		font-size: 36px;
		color: #FFFFFF;
		text-align: center;
		padding-top: 80px;
		padding-bottom: 100px;
	}
	
	.main-bottom img {
		width: 1071px;
		height: 146px;
	}
</style>